module.exports = __webpack_public_path__ + "static/solu-2-d14564204ed27c94c8ed53b2da6d18bd.jpg";